import { Input, OnInit, OnDestroy, AfterViewInit, Directive, Type, ChangeDetectorRef } from "@angular/core";
import { Permission, form_control, PermissionValues, actionInfo, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { HttpCommonService, AccountService, ShowToastrService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { AppInjector } from "../../shared.module";
import { ITab, TabularService } from "../../../tabular/tabular.service ";
import { UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn, ValidationErrors } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { FormContainerModel } from "../../../tabular/form-container-model";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { FormCanDeactivate } from "./form-can-deactivate";
import { SelectorService } from "./selector.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { ReportInfo, StimulSoftReportComponent } from "src/app/stimul-soft-report/stimul-soft-report.component";
import { ReportKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { UserSystemLog } from "projects/sepidz-web-framework/src/lib/models/user-System-Log.model";
import * as XLSX from "xlsx";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

export function isNumber(value: any) {
  return typeof value === "number";
}

@Directive()
export class BaseFormComponent<T> extends FormCanDeactivate implements OnInit, OnDestroy, AfterViewInit {
  @Input() public apiName: string;
  @Input() public areaName: string;
  @Input() label: string;
  @Input() currentrow: any = <any>{};
  @Input() parentrow: any = <any>{};

  public isClosing: boolean;
  public detailName: string;
  public isCanceling: boolean = false;
  public afterDataLoaded: BehaviorSubject<boolean>;
  public ignoreFormGroupWithDetailName = false;
  public model: T = <T>{};
  public changeNoCheck: boolean = false;
  public ReportSelectorForm: Type<any>;
  public ReportCopyForm: Type<any>;
  public currentReport: string = "print";
  public defaultCoumnNumber: number = 4;
  public reportName: string;
  public reportList: SaveReportFile[];
  public reportKinds = ReportKindInfo.reportKinds;
  public pathPreFix: string;
  public ngUnsubscribe = new Subject<void>();
  public noLoadData: boolean = false;
  public id: number;
  public columns: form_control[] = [];
  public orignalColumns: form_control[] = [];
  public managePermission: PermissionValues = Permission.managePermission;
  public createPermission: PermissionValues = Permission.createPermission;
  public editPermission: PermissionValues = Permission.editPermission;
  public deletePermission: PermissionValues = Permission.deletePermission;
  public actionList: actionInfo[] = [];
  public isNewRow = false;
  public isSaving: boolean;
  public isFocusFinish: boolean;
  public isSaved: boolean = false;
  public showValidationErrors: boolean = true;
  public customColumnInfoApi: string = "";
  public selectedValues: { [key: string]: boolean } = {};
  public controls: Array<form_control>;
  public formGroup: UntypedFormGroup;
  public isMultiBranch: boolean;
  public changesSavedCallback: () => void;
  public changesFailedCallback: () => void;
  public changesCancelledCallback: () => void;

  protected submitted = false;
  protected NoMaxCode = false;
  protected route: ActivatedRoute;
  protected dialogService: SimpleModalService;
  protected tabsservice: TabularService;
  protected accountService: AccountService;
  protected translateText: TranslateService;
  protected _id: FormContainerModel;
  protected VoucherKind: VoucherKindInfo;
  protected sts: ShowToastrService;
  protected httpCommonService: HttpCommonService;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super();
    this.httpCommonService = AppInjector.get(HttpCommonService);
    this.route = AppInjector.get(ActivatedRoute);
    this.accountService = AppInjector.get(AccountService);
    this.translateText = AppInjector.get(TranslateService);
    this.dialogService = AppInjector.get(SimpleModalService);
    this.sts = AppInjector.get(ShowToastrService);
    this.afterDataLoaded = new BehaviorSubject<boolean>(false);
    const info = this.accountService.authService.currentInformation();
    this.isMultiBranch =
      (info.BranchingAdvancedEnabled || info.BranchingLightEnabled || info.RestaurantCallCenter) &&
      this.accountService.authService.currentBranch?.AccessToAllBranches;
  }

  async ngOnInit() {
    if (this._id?.metadata?.id) {
      if (!this.tabsservice.tabItemOnCloseableIds.some((x) => x === this._id?.metadata?.id))
        this.tabsservice.tabItemOnCloseableIds.push(this._id?.metadata?.id);
      this.tabsservice.tabItemOnCloseableIds.push();
      this.tabsservice.tabItemOnClosing.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x && x === this._id.metadata.id && !this.isClosing && this.canDeactivate()) {
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
          this.tabsservice.tabItemOnCanClosing.next(this._id.metadata.id);
          this.loadReports();
        }
      });
    }
    if (this.noLoadData && this.currentrow) this.model = Object.assign({}, this.currentrow as T);
    await this.setColumns();
    if (this.currentrow && this.currentrow.Id) this.id = !this.id ? this.currentrow.Id : this.id;
    else if (!this.noLoadData) this.newRow();
    if (this.id && !this.noLoadData) {
      try {
        const data = await this.httpCommonService.getItem<T>(this.apiName, this.id).pipe(take(1)).toPromise();
        if (data) {
          this.model = <T>{};
          Object.assign(this.model, data as T);
          this.isNewRow = this.model === undefined;
          this.afterDefult();
          this.setdefault();
          this.setColumnAttribute();
          if (this.detailName && !this.ignoreFormGroupWithDetailName) this.setFormGroup(this.model[this.detailName]);
          else this.setFormGroup(this.model);
          this.afterDataLoaded.next(true);
          this.formGroup.markAsPristine();
        }
      } catch (error) {
        this.getFailedHelper(error);
      }
    } else {
      this.setdefault();
      this.afterDefult();
      if (this.detailName && !this.ignoreFormGroupWithDetailName) this.setFormGroup(this.model[this.detailName]);
      else this.setFormGroup(this.model);
    }
    this.setUserSystemLog();
    if (this.cd) this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.columns = undefined;
    this.orignalColumns = undefined;
    this.formGroup = undefined;
    this.managePermission = undefined;
    this.actionList = undefined;
    this.model = undefined;
    this.currentrow = undefined;
    this.parentrow = undefined;
    this.ReportSelectorForm = undefined;
    this.ReportCopyForm = undefined;
    this.reportList = undefined;
  }

  translate(str: string): string {
    return this.translateText.instant(str);
  }

  setdefault(): void {
    if (this.detailName && !this.ignoreFormGroupWithDetailName) this.setFormGroup(this.model[this.detailName]);
    else this.setFormGroup(this.model);
  }

  afterDefult(): void {
    this.cd.markForCheck();
  }

  setValue(key: string, value: any, validator: boolean = false, patternKey: string = undefined): void {
    if (!this.formGroup) {
      let group: any = {};
      this.formGroup = new UntypedFormGroup(group);
    }

    const controls = this.formGroup.controls;
    if (!controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
    else controls[key].setValue(value);

    controls[key].clearValidators();
    if (validator && controls[key]) controls[key].setValidators(Validators.required);
    if (patternKey) controls[key].setValidators(Validators.pattern(patternKey));
  }

  addControl(): void {
    this.cd.markForCheck();
  }

  setUserSystemLog(): void {
    if (!this.httpCommonService) return;
    let log: UserSystemLog = <UserSystemLog>{};
    const currentUser = this.accountService.authService.currentUser;
    log.UserId = currentUser.Id;
    log.UserName = currentUser.UserName;
    log.DisplayName = currentUser.DisplayName;
    log.SystemName = this.areaName?.length > 20 ? this.areaName.substring(20) : this.areaName;
    log.FormName = this.constructor.name.length > 100 ? this.constructor.name.substring(100) : this.constructor.name;
    log.FormTitle = this.getFormTitle() ?? this.label;
    if (log.FormTitle.length > 100) log.FormTitle = log.FormTitle.substring(100);
    this.httpCommonService
      .create("UserSystemLog/SaveData", log)
      .pipe(take(1))
      .toPromise()
      .then(
        (x) => {},
        (error) => {
          console.timeLog(error);
        }
      );
  }

  async setColumns() {
    if (!this.apiName) return;
    try {
      const data = await this.httpCommonService
        .getControlsList(this.customColumnInfoApi ? this.customColumnInfoApi : this.apiName.split("/")[0], this.customColumnInfoApi ? true : false)
        .pipe(take(1))
        .toPromise();
      if (data) {
        (data as form_control[]).forEach((x) => {
          x.tabOrder = 0;
        });
        if (this.detailName) {
          this.orignalColumns = (data as form_control[]).find((f) => f.name === this.detailName).DetailControlModels[this.detailName];
          this.columns = this.orignalColumns.filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnAttribute();
          this.setColumnNumber(this.columns);
          this.setFormGroup(this.model[this.detailName]);
        } else {
          this.orignalColumns = data as form_control[];
          this.columns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.setColumnAttribute();
          this.setColumnNumber(this.columns);
          this.setFormGroup(this.model);
        }
        this.cd.markForCheck();
      }
    } catch (error) {
      this.getFailedHelper(error);
    }
  }

  setColumnNumber(columns: form_control[], columnNumber = this.defaultCoumnNumber): void {
    if (columns.some((x) => x.columnNumber && x.isFloat && x.formVisible)) return;
    let index: number = 0;
    columns
      .filter((x) => !x.columnNumber && !x.isFloat && x.formVisible)
      .forEach((x) => {
        index++;
        x.userClass = "select-sm";
        x.columnNumber = 1;
        if (index % columnNumber === 0) x.isFloat = 0;
        else x.isFloat = 1;
      });
  }

  setColumnAttribute(): void {}

  getDetailControlModels(keyName: string): any {
    const detailControlModels = this.orignalColumns?.find((x) => x.name === keyName)?.DetailControlModels;
    if (detailControlModels) return detailControlModels[keyName];
    return [];
  }

  setMaxCode(): void {
    this.setdefault();
  }

  protected getDataFromFormGroup(): T {
    Object.keys(this.formGroup.controls).forEach((key) => {
      if (this.detailName && !this.ignoreFormGroupWithDetailName) this.model[this.detailName][key] = this.formGroup.controls[key].value;
      else this.model[key] = this.formGroup.controls[key].value;
    });
    return this.model;
  }

  preSave(): void {}

  public async save() {
    try {
      this.preSave();
      if (!this.isSaving) {
        if (this.isValid()) {
          this.beforupdate();
          this.sts.showToast("info", "", this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SavingChanges"));
          this.isSaving = true;
          this.isSaved = false;
          if (this.isNewRow || this.id === undefined || this.id === 0 || Number.isNaN(this.id) || this.id === null) {
            await this.httpCommonService
              .create(this.apiName, this.getDataFromFormGroup())
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => this.saveSuccessHelper(row),
                (error) => this.saveFailedHelper(error)
              );
          } else {
            await this.httpCommonService
              .update(this.apiName, this.getDataFromFormGroup())
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (response) => this.saveSuccessHelper(),
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }

  protected isCloseable(): boolean {
    return true;
  }

  public saveSuccessHelper(row?: any): void {
    this.isClosing = false;
    this.submitted = true;
    this.selectorService.submitted$.next(this.submitted);
    if (row) {
      this.model["Id"] = row;
      this.id = row;
    }
    this.isSaving = false;
    this.showValidationErrors = false;
    if (this.isNewRow)
      this.sts.showToast(
        "success",
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.Successful"),
        `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.Information")} ${this.label} ${this.translate(
          "ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SuccessfullyCreated"
        )}`
      );
    else
      this.sts.showToast(
        "success",
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.Successful"),
        `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.InformationChanges")}  ${this.label}  ${this.translate(
          "ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SavedSuccessfully"
        )} `
      );
    if (this.changesSavedCallback) this.changesSavedCallback();
    this.currentrow = this.model;
    this.afterupdate();
    this.isSaved = true;
    this.result = this.model;
    if (this.isCloseable()) this.close();
    this.selectorService.submitted$.next(false);
  }

  protected saveFailedHelper(error: any): void {
    this.submitted = false;
    this.selectorService.submitted$.next(this.submitted);
    this.isClosing = false;
    this.isSaving = false;
    this.sts.showToast(
      "danger",
      this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SaveError"),
      `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorSavingChanges")}: ${Utilities.getHttpResponseMessage(error)}`
    );
    this.sts.showDialog(
      `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorSavingChanges")}: ${Utilities.getHttpResponseMessage(error)}`,
      this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorMessage")
    );
    if (this.changesFailedCallback) this.changesFailedCallback();
    this.saveHasError();
  }

  protected saveHasError(): void {}

  protected getFailedHelper(error: any): void {
    this.isSaving = false;
    var errr = Utilities.getHttpResponseMessage(error);
    if (!errr.includes("Nullable object must have a value."))
      this.sts.showDialog(
        `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorLoadingInformation")}: ${Utilities.getHttpResponseMessage(
          error
        )}`,
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorMessage")
      );
    if (this.changesFailedCallback) this.changesFailedCallback();
  }

  public cancel(): void {
    this.isCanceling = true;
    if (!this.isClosing && this.canDeactivate()) {
      this.showValidationErrors = false;
      this.sts.showToast(
        "primary",
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.OptOut"),
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.OperationAbortedUser")
      );
      this.close();
    }
  }

  newRow(): void {
    this.id = 0;
    this.isNewRow = true;
    this.showValidationErrors = true;
    this.selectedValues = {};
    this.model = <T>{};
    this.setdefault();
    if ((!this.id || this.id <= 0 ) && !this.NoMaxCode) this.setMaxCode();
    if (this.detailName && !this.ignoreFormGroupWithDetailName) this.setFormGroup(this.model[this.detailName]);
    else this.setFormGroup(this.model);
    this.setColumnAttribute();
  }

  close(): void {
    if (this._id) {
      this.tabsservice.tabItemonRefreshData.next(this.apiName);
      this.tabsservice.closeById(this._id.metadata.id);
    } else this.closeModal();
  }

  isValid(): boolean {
    return this.formGroup?.valid;
  }

  getFormTitle(): string {
    return (
      (this.label ?? "") +
      "-" +
      (this.isNewRow
        ? ` ${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.New")}`
        : `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.Edit")} `)
    );
  }

  afterupdate(): void {
    this.isNewRow = false;
    this.currentrow = this.model;
    if (!this.isCloseable()) this.ngOnInit().then();
  }

  beforupdate(): void {}

  ngAfterViewInit(): void {}

  getColumnCaption(key: string): string {
    let column = this.orignalColumns.find((x) => x.name === key);
    if (column !== undefined) return column.label;
    return key;
  }

  setFormGroup(entity: any = null, col: form_control[] = null): UntypedFormGroup {
    let hasOut: boolean = false;
    if (entity === null) entity = this.model;
    let group: any = {};
    if (!col) col = this.orignalColumns ? this.orignalColumns : [];
    else hasOut = true;
    if (col.length > 0) col = col.sort((a, b) => a.order - b.order);
    col.forEach((question) => {
      switch (question.textType) {
        case "text":
        case "password":
          {
            let validator: ValidatorFn[] = [];
            if (question.required && !question.disabled) validator.push(Validators.required);
            if (question.minLength && question.minLength > 0) validator.push(Validators.minLength(question.minLength));
            if (question.maxLength && question.maxLength > 0) validator.push(Validators.maxLength(question.maxLength));
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));
            if (question.patternKey) validator.push(Validators.pattern(question.patternKey));
            group[question.name] =
              !question.disabled && validator.length > 0
                ? new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled }, validator)
                : new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled });
          }
          break;
        case "checkbox":
          group[question.name] =
            !question.disabled && question.required
              ? new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled }, Validators.required)
              : new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled });
          break;
        case "number":
          {
            let validator: ValidatorFn[] = [];
            if (question.required && !question.disabled) validator.push(Validators.required);
            if (question.minLength && question.minLength > 0) validator.push(Validators.minLength(question.minLength));
            if (question.maxLength && question.maxLength > 0) validator.push(Validators.maxLength(question.maxLength));
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));
            group[question.name] =
              !question.disabled && validator.length > 0
                ? new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled }, validator)
                : new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled });
          }
          break;
        case "date":
          group[question.name] =
            !question.disabled && question.required
              ? new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled }, Validators.required)
              : new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled });
          break;
        default:
          if (question.controlType)
            group[question.name] =
              !question.disabled && question.required
                ? new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled }, Validators.required)
                : new UntypedFormControl({ value: !entity ? null : entity[question.name], disabled: question.disabled });
          break;
      }
    });
    if (col && col.length > 0 && entity) {
      if (entity["BranchId"]) group["BranchId"] = new UntypedFormControl(!entity ? 0 : entity["BranchId"]);
      group["Id"] = new UntypedFormControl(!entity["Id"] ? 0 : entity["Id"]);
      if (hasOut === true) return new UntypedFormGroup(group);
      this.formGroup = new UntypedFormGroup(group);
      this.formGroup.updateValueAndValidity();
      this.cd.markForCheck();
      this.addControl();
    }
  }

  setFormGroupErrors(): any[] {
    if (!this.formGroup?.valid) {
      const result = [];
      Object.keys(this.formGroup.controls).forEach((key) => {
        const controlErrors: ValidationErrors = this.formGroup.get(key).errors;
        if (controlErrors) {
          Object.keys(controlErrors).forEach((keyError) => {
            result.push({
              control: key,
              error: keyError,
              caption: this.getColumnCaption(key),
              value: controlErrors[keyError],
            });
          });
        }
      });

      return result;
    }
  }

  getSumWithKey(list: any[], key: string): number {
    if (list.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length <= 0) return 0;
    return list
      .filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
      .reduce((s: number, b: number) => (s ?? 0) + (b[key] ?? 0), 0);
  }

  closeForm(flag: boolean = false): void {
    if (flag && (this.isCanceling || this.isCloseable())) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    this.isClosing = false;
  }

  setAllUnTouched() {
    const controls = this.formGroup.controls;
    Object.keys(controls).forEach((key) => {
      if (controls[key].touched === true) controls[key].markAsUntouched();
    });
  }

  canDeactivate(): boolean | Observable<boolean> {
    if (!this.isClosing) {
      this.isClosing = true;
      if (!(this.formGroup && this.formGroup.dirty && this.formGroup.touched) || this.changeNoCheck) return true;

      this.sts.showDialog(
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.UnsavedDataWillExit"),
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.Warning"),
        DialogType.confirm,
        () => this.closeForm(true),
        () => this.closeForm(false)
      );
    }
    return false;
  }

  loadReports(): void {
    if (!this.apiName) return;
    let SystemKindName = this.pathPreFix;
    if (this.VoucherKind?.VoucherKindId) SystemKindName = `${SystemKindName}_${this.VoucherKind?.VoucherKindId}`;
    this.httpCommonService
      .getList(this.apiName.split("/")[0] + "/GetReportInfo/" + SystemKindName + "/" + this.apiName.split("/")[0])
      .pipe(take(1))
      .toPromise()
      .then((data) => {
        if (data) this.reportList = data as [];
        if (this.reportName) this.reportList = this.reportList.filter((x) => x.FileName === this.reportName);
      });
  }

  changeReport(reprtName: string): void {
    if (!this.apiName) return;
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = this.reportName;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.FileName = `${this.reportName}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.SystemKindName = this.pathPreFix;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.SystemKindName = `${this.pathPreFix}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.CategoryName = this.apiName.replace("/", "_");
    if (this.reportList && this.reportList.length > 1) {
      this.dialogService
        .open(
          this.ReportSelectorForm,
          {
            dataList: this.reportList,
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SelectReport"),
          },
          { autoFocus: true, closeOnEscape: false, closeOnClickOutside: false }
        )
        .pipe(take(1))
        .subscribe((model: any) => {
          if (model) {
            saveReportFile = model;
            this.setReport(reprtName, saveReportFile);
          }
        });
      this.currentReport = "print";
      return;
    }
    if (this.reportList && this.reportList.length === 1) {
      saveReportFile = this.reportList[0];
    } else {
      this.reportList = [];
      this.reportList.push(saveReportFile);
    }
    this.setReport(reprtName, saveReportFile);
  }

  deleteReport(saveReportFile: SaveReportFile): void {
    if (!this.apiName) return;
    this.httpCommonService
      .deleteByParameter(this.apiName.split("/")[0] + "/DeleteReportInfo/?id=" + saveReportFile.Id)
      .pipe(take(1))
      .toPromise()
      .then(
        (results) => {
          this.sts.showToast("success", "", this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ReportDeletedSuccessfully"));
          setTimeout(() => this.loadReports(), 200);
        },
        (error) => {
          this.sts.showDialog(
            `${this.label}: ${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ErrorDeletingReport")
          );
        }
      );
  }

  setReport(reportName: string, saveReportFile: SaveReportFile, data: any = null): void {
    if (reportName === "deleteReport") {
      this.sts.showDialog(
        `${this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.SureWantDeleteReport")}`,
        this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.DeleteReport"),
        DialogType.confirm,
        () => this.deleteReport(saveReportFile)
      );
      return;
    }
    if (this.model) {
      switch (reportName) {
        case "print":
          this.print(saveReportFile, this.apiName, data?.length ? data : [this.model]);
          break;
        case "preview":
          this.preview(saveReportFile, this.apiName, data?.length ? data : [this.model]);
          break;
        case "editReport":
          this.editReport(saveReportFile, this.apiName, data?.length ? data : [this.model]);
          break;
        case "copyReport":
          this.copyReport(saveReportFile, data?.length ? data : [this.model]);
          break;
      }
    }
  }

  print(saveReportFile: SaveReportFile, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.print;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }

  preview(saveReportFile: SaveReportFile, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.preview;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.pathPreFix = this.pathPreFix;
    reportInfo.startDate = saveReportFile.startDate;
    reportInfo.endDate = saveReportFile.endDate;
    reportInfo.startNumber = saveReportFile.startNumber;
    reportInfo.endNumber = saveReportFile.endNumber;

    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }

  copyReport(saveReportFile: SaveReportFile, dataList: any[]) {
    this.dialogService
      .open(
        this.ReportCopyForm,
        {
          currentrow: null,
          apiName: this.apiName,
          areaName: this.areaName,
          label: this.translate("ClientApp.Projects.FrameWorkShell.Shared.Controls.Base.ReportDuplication"),
        },
        { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
      )
      .pipe(take(1))
      .subscribe((model: any) => {
        if (model) {
          saveReportFile.ReportTitle = model.ReportTitle;
          saveReportFile.Id = 0;
          this.copyNewReport(saveReportFile, saveReportFile.FileName, this.apiName, dataList);
        }
      });
  }

  copyNewReport(saveReportFile: SaveReportFile, oldReportName: string, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};

    reportInfo.reportKind = ReportKind.editReport;
    reportInfo.apiName = apiName;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.FileName = `${this.reportName}_${this.VoucherKind?.VoucherKindId}_${this.reportList.length}`;
    else saveReportFile.FileName = `${this.reportName}_${this.reportList.length}`;
    reportInfo.reportTitle = this.label;
    reportInfo.dataList = dataList;
    reportInfo.oldReportName = oldReportName;
    reportInfo.pathPreFix = this.pathPreFix;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.startDate = saveReportFile.startDate;
    reportInfo.endDate = saveReportFile.endDate;
    reportInfo.startNumber = saveReportFile.startNumber;
    reportInfo.endNumber = saveReportFile.endNumber;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
    setTimeout(() => this.loadReports(), 200);
  }

  editReport(saveReportFile: SaveReportFile, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.editReport;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.reportTitle = saveReportFile.ReportTitle;
    reportInfo.dataList = dataList;
    reportInfo.pathPreFix = this.pathPreFix;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.startDate = saveReportFile.startDate;
    reportInfo.endDate = saveReportFile.endDate;
    reportInfo.startNumber = saveReportFile.startNumber;
    reportInfo.endNumber = saveReportFile.endNumber;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }

  parseExcelDoc(file: File): Promise<any> {
    let reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        resolve(data);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }
}
